import { render, staticRenderFns } from "./PartnersWithBillableWidget.vue?vue&type=template&id=1515fbf2&"
import script from "./PartnersWithBillableWidget.vue?vue&type=script&lang=js&"
export * from "./PartnersWithBillableWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports